module.exports = __webpack_public_path__ + "img/banner_img.7b87c152.png";